/* ============================================================
   MUSE DISC — Hero JS
   Entrance animation + background parallax
   ============================================================ */

(function () {
  const hero       = document.getElementById('hero');
  const heroBg     = document.getElementById('hero-bg');
  const title      = hero?.querySelector('.hero__title');
  const lines      = hero?.querySelectorAll('.js-hero-line');
  const scrollHint = hero?.querySelector('.js-scroll-hint');

  if (!hero) return;

  // --- Entrance animation ----------------------------------
  // Guard: prevents double-fire from MutationObserver + setTimeout fallback
  let entranceDone = false;

  function runEntrance() {
    if (entranceDone) return;
    entranceDone = true;

    if (typeof gsap === 'undefined') {
      [title, ...lines].forEach(el => {
        if (el) { el.style.opacity = 1; el.style.transform = 'none'; }
      });
      return;
    }

    const tl = gsap.timeline({ defaults: { ease: 'power3.out' } });

    if (title) {
      tl.to(title, { opacity: 1, y: 0, duration: 1 });
    }
    if (lines?.length) {
      tl.to(lines, { opacity: 1, y: 0, duration: 0.8, stagger: 0.12 }, '-=0.6');
    }
    if (scrollHint) {
      tl.to(scrollHint, { opacity: 1, duration: 0.6 }, '-=0.2');
    }
  }

  const loader = document.getElementById('loader');
  if (loader) {
    const observer = new MutationObserver(() => {
      if (!document.getElementById('loader')) {
        observer.disconnect();
        runEntrance();
      }
    });
    observer.observe(document.body, { childList: true });
    // Fallback: runs only if observer never fires (entranceDone guards against double-fire)
    setTimeout(runEntrance, 2600);
  } else {
    runEntrance();
  }

  // --- Parallax on scroll ----------------------------------
  if (heroBg && typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    gsap.to(heroBg, {
      yPercent: 30,
      ease: 'none',
      scrollTrigger: {
        trigger: hero,
        start: 'top top',
        end: 'bottom top',
        scrub: 1.5, // smooth lag — avoids jerkiness
      },
    });
  }

  // --- Hide scroll hint on first scroll --------------------
  if (scrollHint) {
    window.addEventListener('scroll', function hideHint() {
      if (window.scrollY > 80) {
        scrollHint.style.opacity = '0';
        scrollHint.style.transition = 'opacity 0.4s';
        window.removeEventListener('scroll', hideHint);
      }
    }, { passive: true });
  }
})();
